import {connect} from 'react-redux';
import {submit} from 'redux-form';
import ConfirmDialog from 'shared/ConfirmDialog.jsx';
import {handleRosterConfirmationCancel} from './actions';
import {setRosterConfirmationVisibility} from '../shared/actionTypes';

const mapStateToProps = state => ({
  visible: state.registration.shared.rosterConfirmationVisible,
  title: 'Confirm Before Leave',
  content: 'There are unsaved roster changes. What would you like to do?',
  cancelBtnLabel: 'Discard and continue',
  confirmBtnLabel: 'Save and continue'
});

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleRosterConfirmationCancel()),
  onCloseClick: () => dispatch(setRosterConfirmationVisibility(false)),
  onConfirmClick: () => dispatch(submit('entryForm'))
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/features/registration/manage/RosterConfirmationDialogContainer.jsx